import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import EditorialModule from 'dibs-editorial-module/exports/EditorialModule';

import styles from './SbSharedWordpressArticles.scss';

const SbSharedWordpressArticlesComponent = ({ itemSearch }) => {
    const editorialArticles = itemSearch?.editorialArticles;
    if (!editorialArticles?.totalResults) {
        return null;
    }
    return (
        <div className={styles.container}>
            <EditorialModule editorialArticles={editorialArticles} />
        </div>
    );
};

SbSharedWordpressArticlesComponent.propTypes = {
    itemSearch: PropTypes.object.isRequired,
};

export const SbSharedWordpressArticles = createFragmentContainer(
    SbSharedWordpressArticlesComponent,
    {
        itemSearch: graphql`
            fragment SbSharedWordpressArticles_itemSearch on ItemSearchQueryConnection {
                editorialArticles(first: 2) {
                    totalResults
                    ...EditorialModule_editorialArticles
                }
            }
        `,
    }
);
